import { t } from "i18next";
import { Switch } from "ui";

import { ProductSetFormShowOnHomeFieldProps } from "../ProductSetForm.types";

import styles from "../ProductSetForm.module.scss";

export const ProductSetFormShowOnField = ({
  value,
  onChange,
  title,
  description,
  disabled = false
}: ProductSetFormShowOnHomeFieldProps) => {
  return (
    <div className={styles.form_showOnHomeField}>
      <div>
        <div className={styles.form_boldText}>{t(title)}</div>
        <div className={styles.form_showOnHomeField_description}>
          {t(description)}
        </div>
      </div>
      <Switch checked={value} onChange={onChange} disabled={disabled} />
    </div>
  );
};
